import { useAddinData } from "../addins/useAddinData";
import AddInIds from "@/constants/AddInIds";
import { DiagnosticView } from "@/models/DiagnosticView";

export function useDiagnosticViews() {
  return useAddinData<DiagnosticView>(AddInIds.diagnosticViews);
}
